/* eslint-disable react-native/no-inline-styles */
import {useIsFocused} from '@react-navigation/native';
import React, {useEffect, useState} from 'react';
import {StyleSheet, Text} from 'react-native';
import {useDispatch, useSelector} from 'react-redux';
import {postAnnouncementSeen} from '../../../apis';
import {getAnnouncments, setCheckAnnouncement} from '../../../redux/actions';
import {useAsyncFn, useAsyncRetry, useIsLandscape} from '../../../utils';
import {AppLoadingIndicator, Page} from '../../components';
import DetailModal from './components/DetailModal';
import RowCard from './components/RowCard';

const Inbox = () => {
  //const [selectedIndex, setSelectedIndex] = useState(0);
  const [detailsToShow, setDetailsToShow] = useState();
  const dispatch = useDispatch();
  const isFocused = useIsFocused();
  const isLandscape = useIsLandscape();
  const announcements = useSelector(({inbox}) => inbox.announcements);
  const haveNewNotif = useSelector(({inbox}) => inbox.haveNewNotif);

  const [, handleSeenNotifs] = useAsyncFn(async () => {
    await postAnnouncementSeen();
    dispatch(setCheckAnnouncement(false));
  }, []);

  const {loading, retry: handleGetAnnouncments} = useAsyncRetry(
    () => dispatch(getAnnouncments()),
    [],
  );

  useEffect(() => {
    if (haveNewNotif) {
      handleSeenNotifs();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isFocused) {
      handleGetAnnouncments();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFocused]);

  return (
    <>
      <Page
        header={{title: 'Announcement', showDrawerAction: true}}
        scrollViewStyle={[
          styles.scrollView,
          isLandscape ? {paddingHorizontal: 8} : undefined,
        ]}>
        {loading ? (
          <AppLoadingIndicator />
        ) : (
          <>
            <>
              {announcements?.length === 0 && (
                <>
                  <Text
                    style={{textAlign: 'center', marginTop: 20, fontSize: 16}}>
                    No announcements found
                  </Text>
                </>
              )}
            </>
            <>
              {announcements?.map((item, index) => (
                <RowCard
                  data={item}
                  key={index}
                  onPress={() =>
                    setDetailsToShow({
                      title: item.title,
                      text: item.description,
                      link: item.media_file_name,
                      media_type: item.media_type,
                    })
                  }
                />
              ))}
            </>
          </>
        )}
      </Page>
      <DetailModal
        data={detailsToShow}
        onClose={() => setDetailsToShow(undefined)}
      />
    </>
  );
};

const styles = StyleSheet.create({
  scrollView: {
    paddingBottom: 250,
  },
});

export default Inbox;
